<template>
    <div class="row">
        <slot></slot>
    </div>
</template>